import { render, staticRenderFns } from "./iso14000Doc.vue?vue&type=template&id=1c1a4a5a"
import script from "./iso14000Doc.vue?vue&type=script&lang=js"
export * from "./iso14000Doc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c1a4a5a')) {
      api.createRecord('1c1a4a5a', component.options)
    } else {
      api.reload('1c1a4a5a', component.options)
    }
    module.hot.accept("./iso14000Doc.vue?vue&type=template&id=1c1a4a5a", function () {
      api.rerender('1c1a4a5a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/env/iso14000Doc.vue"
export default component.exports